import Header from "../../Header/Header";
import logo from "../../../assets/logoa 1.png";
import toast from "react-hot-toast";
import { AdminLogin } from "../../../services/kojaServices";
import { useNavigate } from "react-router-dom";
const ExpertLogin = () => {
  const navigate = useNavigate()

  const loginExpert = async()=> {
    const username = document.getElementById("username").value
    const password = document.getElementById('password').value
    if( username && password){
     try{
      const sendData={
        user_name : username,
        password
        }
        const {data} = await AdminLogin(sendData)
        console.log(data)
        localStorage.setItem("token", data.result.token);
        localStorage.setItem("refreshToken", data.result.refreshToken);
       if(data.result.role === 'Expert')
       {
         navigate("/expert/requests");
        window.location.reload()
       }else if (data.result.role === 'Admin'){
        navigate("/admin/experts");
        window.location.reload()
       }
     }catch(err){
      console.log(err)
      toast.error(`${err.response.data.result_message}`)
     }

    }else{
      toast.error("نام کاربری و پسورد نمی تواند خالی باشد")
    }
  }
  return (
    <div className="admin-login">
      <Header />
      <div className="user-login-box1 mt-3 text-center">
        <img alt="" className="user-login-logo" src={logo} />
        <form onSubmit={(e)=>{
          e.preventDefault()
          loginExpert()}}>
        <div className="user-login-box2">
          <h3 className="user-login-label">ورود</h3>
          <input id="username" placeholder="نام کاربری" className="userlogin-input" />
          <input id="password" type="password" placeholder="رمز عبور" className="userlogin-input" />
          <div className="user-login-btn-box">
            <button type="submit" className="btn user-login-btn" onClick={()=>{loginExpert()}}>ورود</button>
          </div>
          <p style={{ color: "#fff" }}>فراموشی رمز عبور</p>
        </div>
        </form>
      </div>
    </div>
  );
};

export default ExpertLogin;
